import * as React from 'react';
import Radio from '../radio';
import Text from '../text';
import FormContentSearch from './form-content.search';

import { RadioList as Props, SearchItem } from './form-content.types';
import classNames from 'classnames';

const RadioList: React.FC<Props> = props => {
  const [searchTerm, setSearchTerm] = React.useState('');
  const [searchResult, setSearchResult] = React.useState<SearchItem[]>();
  return (
    <div>
      {'searchProps' in props ? (
        <FormContentSearch
          {...props.searchProps}
          searchResult={setSearchResult}
          searchTerm={setSearchTerm}
        />
      ) : undefined}
      {props.categories.map((category, categoryIndex) => (
        <div key={categoryIndex}>
          {category.header &&
          category.options.length > 0 &&
          searchTerm.length === 0 ? (
            <Text
              className={classNames('form-content__group-title', {
                hidden: searchTerm.length > 0,
              })}
              theme={Text.themes.emphasis}
            >
              {category.header}
            </Text>
          ) : undefined}
          {category.options.map((radio, i) => {
            const isInSearchResults =
              searchTerm.length > 0
                ? searchResult?.find(
                    item =>
                      item.key.toLowerCase() === radio.value.toLowerCase(),
                  )
                : undefined;

            if (searchTerm.length > 0 && !isInSearchResults) return;

            return (
              <div key={i} className="form-content__radio-button">
                <Radio {...radio} isUnderline={true} />
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default RadioList;
